import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    // This will be handled by the root component
  },
  component: IndexComponent,
});

function IndexComponent() {
  // This component will redirect based on user state
  return null;
}
